/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import edittemlatefieldpopup from "../edittemplatefieldpopup/edittemplatefieldpopup.vue"
import jwt_decode from "jwt-decode";
export default {
  name: "crfsingle",
 components: {
    customModal,
    edittemlatefieldpopup
  },
  props: {
        tempId:{
            type: String,
            default: ''
        },
        formId:{
            type: String,
            default: ''
        },
        comments:{
          type: String,
          default:''
        }
    },
  async mounted() {
    this.email=jwt_decode(this.idtoken).email;
    await this.getdata();
     window.addEventListener("studyIdChanged", async () => {
        await this.getdata();
    });
  },
  data() {
    return {
      email:"",
      disableeditcheckfor:["header", "subheader", "summary"],
      idtoken: store.getters.getIdToken,
      baseurl: process.env.VUE_APP_Service_URL,
      editcheckmodal: false,
      fromdata:{},
      sourcefromdata:{},
      crfdata:[],
      crfsourcedata:[],
      editcheckdetails:[],
      selectedtemplate:"",
      approveorreject:"",
      approveorrejectpopup: false,
      approvecomments:"",
      componentModal: false,     // controls <teleport> modal visibility
    selectedmenu: "",          // which UI block to show
    fieldname: "",             // v-model for field name
    labeltext: "",             // v-model for label
    values: [],                // selected validations (Multiselect)
    radiooptionsarray: [],     // shared list for radio/dropdown options
    radioorientation: "vertical", // for radio alignment
    isformlocked: false,       // your template checks this often
    refreshFlags: {            // tab selection flags; keep only 'general'
      general: true
    },
    // if you use these in validation editors inside the general tab:
    generalValidations: [],
    rangeErrors: [],
    // date/time helpers used in some general sections:
    dateFormat: "",
    timeFormat: "",
    minDate: "",
    maxDate: "",
    minvalue: null,
    maxvalue: null,
    minlength: null,
    maxlength: null,
    optiongroups: { results: [] },
     options: [],
    commonvalidations: [],
    generaldateOptions: [],
    generaltimeOptions: [],
    generalnumberanddateOptions: [],
    generaldateandtimeOptions: [],
    generalyearOptions: [],
    generaltextareaOptions: [],
    dateList: [],

    // other state you reference
    generalValidationsError: [],
    currentField: null,
    currentFieldPageNo: null,
    currentFieldIndex: null,
    versionhistoryarray: [],
    };
  },
  methods: {
    closeaddnodepopup(){
      this.approveorrejectpopup = false;
    },
     normalizeType(t) {
      if (!t) return "textbox";
      const s = String(t).toLowerCase();
      if (["textbox", "text", "input"].includes(s)) return "textbox";
      if (["dropdown", "select"].includes(s)) return "dropdown";
      if (["radio", "radiobutton", "radiohorizondal"].includes(s)) return "radio";
      if (["date"].includes(s)) return "date";
      if (["time"].includes(s)) return "time";
      if (["textarea", "multiline"].includes(s)) return "textarea";
      if (["header", "heading"].includes(s)) return "header";
      if (["subheader", "subheading"].includes(s)) return "subHeader";
      if (["image", "picture"].includes(s)) return "image";
      if (["year"].includes(s)) return "year";
      if (["dateandtime", "datetime"].includes(s)) return "dateandtime";
      if (["checkbox"].includes(s)) return "checkbox";
      if (["scales", "scale"].includes(s)) return "scales";
      if (["calculation", "calculated"].includes(s)) return "calculation";
      if (["numberanddate"].includes(s)) return "numberanddate";
      if (["qrcode", "qr"].includes(s)) return "qrcode";
      if (["addsurvey"].includes(s)) return "addsurvey";
      if (["repeatedmeasure"].includes(s)) return "repeatedmeasure";
      if (["repeatedmodel"].includes(s)) return "repeatedmodel";
      return "textbox";
    },
    openFieldPopup(field) {
    if (!field) return;
    this.currentField = { ...field };              // shallow clone
    this.currentFieldPageNo = field.pageNo;        // from makecrfdata()
    this.currentFieldIndex = field.indexOnPage;    // from makecrfdata()
    this.componentModal = true;
  },
  closemodaltwo() {
    this.componentModal = false;
    this.currentField = null;
    this.currentFieldPageNo = null;
    this.currentFieldIndex = null;
    this.getdata();
  },
async handleFieldSaved({ pageNo, indexOnPage, field: updatedField }) {
      try {
        const pageIdx = this.fromdata.pages.findIndex(p => p.pageNo === pageNo);
        if (pageIdx === -1) throw new Error(`Page ${pageNo} not found`);

        // VUE 3: replace the field using splice for reactivity
        const merged = {
          ...this.fromdata.pages[pageIdx].field[indexOnPage],
          ...updatedField
        };
        this.fromdata.pages[pageIdx].field.splice(indexOnPage, 1, merged);

        // persist the entire template (adjust endpoint if your API differs)
        await axios.put(
          `${this.baseurl}/forms/template/update?api-version=1.0`,
          this.fromdata,
          { headers: { Authorization: `Bearer ${this.idtoken}`, "Content-Type": "application/json" } }
        );

        // optional: refresh, but local state is already updated
        await this.getdata();

        this.closemodaltwo();
      } catch (e) {
        console.error("Failed to save field:", e);
      }
    },
    async assigntemplate(status) {     
      
        if(status == 'Approved')
          {
            if(confirm("Are you sure you want to approve this form?"))
            {
             
                await axios
                  .put(
                  `${this.baseurl}/forms/digitalform/updatedigitalform`,{
                      "createdUserEmail": "string",
                      "createdUserId": "string",
                      "createdAt": "2022-06-28T10:22:01.286Z",
                      "lastModifiedUserEmail": "string",
                      "lastModifiedUserId": "string",
                      "lastModifiedAt": "2022-06-28T10:22:01.286Z",
                      "digitalFormId": this.formId,
                      "templateId": this.tempId,
                      "approval": [
                        {
                          "assignedTo": "string",
                          "assignedDate": "2022-06-28T10:22:01.286Z",
                          "approvedBy": this.email,
                          "status": status,
                          "comments": this.approvecomments
                        }
                      ]
                    },
                  {
                      headers: {
                      Authorization:  "Bearer " + this.idtoken,
                      "Content-Type": "application/json",
                      },
                  }
                  )
                  .then((res) => {  
                      alert("The form has been approved");
                      this.approveorrejectpopup = false;
                      this.getdata();         
                  })
                  .catch((err) => {
                  console.log(err);
                });
              
            }
          }
        else
          {            
            if(confirm("Are you sure you want to reject this form?"))
            {
              await axios
                  .put(
                  `${this.baseurl}/forms/digitalform/updatedigitalform`,{
                      "createdUserEmail": "string",
                      "createdUserId": "string",
                      "createdAt": "2022-06-28T10:22:01.286Z",
                      "lastModifiedUserEmail": "string",
                      "lastModifiedUserId": "string",
                      "lastModifiedAt": "2022-06-28T10:22:01.286Z",
                      "digitalFormId": this.formId,
                      "templateId": this.tempId,
                      "approval": [
                        {
                          "assignedTo": "string",
                          "assignedDate": "2022-06-28T10:22:01.286Z",
                          "approvedBy": this.email,
                          "status": status,
                          "comments": this.approvecomments
                        }
                      ]
                    },
                  {
                      headers: {
                      Authorization:  "Bearer " + this.idtoken,
                      "Content-Type": "application/json",
                      },
                  }
                  )
                  .then((res) => {  
                      alert("The form has been rejected");
                      this.approveorrejectpopup = false;
                       this.getdata();
                  })
                  .catch((err) => {
                  console.log(err);
                });
              
            }
          }
        
    },
    getcorrectdate(date){
const ymd = new Date(date).toISOString().slice(0, 10);
return ymd;
    },
async approveorrejectfun(approveorreject){
  this.approvecomments = this.comments != "null" ? this.comments : "";
this.approveorreject = approveorreject == "Approve"?"Approve Form":"Reject Form";
this.approveorrejectpopup = true;
},
    setoptions(options) {
  if (!Array.isArray(options)) return "";
  return options
    .map(o => (o && typeof o.optionname === "string" ? o.optionname.trim() : ""))
    .filter(Boolean)
    .join(", ");
    },
    closeeditcheckModal(){
this.editcheckmodal = false;
    },
    async openeditcheckpopup(fieldname){
        const idtoken = store.getters.getIdToken;
      await axios.get(
        `${this.baseurl}/forms/editcheck/geteditcheckbyid?tempId=${this.tempId}&fieldName=${fieldname}`,
        {
            headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
    })
        .then((res) => {
          if(res.data && res.data != null){
          this.editcheckmodal = true;
          this.editcheckdetails = res.data.editCheck;
          }
          else{
            alert("This field does not have any edit check");
          }
        })
        .catch((err) => console.log("error in screen list", err));
    },
async onclosed() {
      this.$router.go(-1);
    },
    async getdata() {
      try {
        const idtoken = store.getters.getIdToken;

        const res = await axios.get(
          `${this.baseurl}/forms/template/get/${this.tempId}?api-version=1.0`,
          {
            headers: {
              Authorization: `Bearer ${idtoken}`,
              "Content-Type": "application/json",
            },
          }
        );

        this.fromdata = res.data;

        this.crfdata = this.makecrfdata();

        await this.getversionhistory(res.data.sourceTemplateId, true);

        console.log("versionhistoryarray", this.versionhistoryarray);

        const englishVersion = this.versionhistoryarray.find(
          (v) =>
            v.version === this.fromdata.version &&
            v.language?.toLowerCase() === "english"
        );

        if (englishVersion) {
          await this.getsourcedata(englishVersion.templateId);
        }

        console.log("crfdata", this.crfdata);
      } catch (err) {
        console.error("Error in getdata:", err);
      }
    },

    async getsourcedata(sourcetemplateid) {
      const idtoken = store.getters.getIdToken;
      await axios.get(
        `${this.baseurl}/forms/template/get/${sourcetemplateid}?api-version=1.0`,
        {
            headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
    })
        .then((res) => {
          this.sourcefromdata = res.data;
          this.crfsourcedata = this.makesourcecrfdata();
        })
        .catch((err) => console.log("error in screen list", err));
    },
    async getversionhistory(templateid, firstload) {
      await axios
        .get(
          `${this.baseurl}/forms/template/getversionhistory?sourceId=${templateid}`,
          {
            headers: {
              Authorization: "Bearer " + this.idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.versionhistoryarray = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
   makecrfdata(){
if (!this.fromdata || !Array.isArray(this.fromdata.pages)) return [];
  return this.fromdata.pages.flatMap((p) => {
    const fields = Array.isArray(p.field) ? p.field : [];
    return fields.map((f, idx) => ({
      ...f,
      pageName: p.pageName,
      pageNo: p.pageNo,
      indexOnPage: idx,
    }));
  });
   },
   makesourcecrfdata(){
if (!this.sourcefromdata || !Array.isArray(this.sourcefromdata.pages)) return [];
  return this.sourcefromdata.pages.flatMap((p) => {
    const fields = Array.isArray(p.field) ? p.field : [];
    return fields.map((f, idx) => ({
      ...f,
      pageName: p.pageName,
      pageNo: p.pageNo,
      indexOnPage: idx,
    }));
  });
   },
  },
};